import formatMoney from "./formatMoney";

export default function OrderDetailsVariantsTable({ order }) {
  return (
    <div className="w-100 px-1 overflow-x-auto">
      <table
        className="table table-striped table-bordered table-hover"
        style={{ width: "100%", direction: "rtl" }}
      >
        <thead>
          <tr>
            <th>ردیف</th>
            <th>عنوان و کد ﺗﻨﻮع کالا (DKPC)</th>
            <th>کد کالا (DKP)</th>
            <th>رنگ / سایز</th>
            <th>کد کالای فروشنده</th>
            <th>بازه زمانی ارسال</th>
            <th>ماهیت کالا</th>
            <th>تعداد سفارش</th>
            <th>قیمت فروش (﷼)</th>
          </tr>
        </thead>
        <tbody>
          {order.variants?.map((variant, vi) => (
            <tr key={vi}>
              <td className="text-center">{vi + 1}</td>
              <td
                className="d-flex align-items-center"
                style={{ gap: 8, minWidth: "250px" }}
              >
                <img
                  src={variant.image_url}
                  alt=""
                  className="rounded"
                  style={{ width: 50, maxHeight: 50 }}
                />
                <span>{variant.title}</span>
              </td>
              <td className="text-center">{variant.productId}</td>
              <td>
                {variant.theme
                  ? Array.isArray(variant.theme)
                    ? variant.theme[0]?.value || "-"
                    : variant.theme
                  : "-"}{" "}
                /{" "}
                {variant.size
                  ? Array.isArray(variant.size)
                    ? variant.size[0]?.value || "-"
                    : variant.size
                  : "-"}
              </td>
              <td className="text-center">{variant.sellerCode || "-"}</td>
              <td>{variant.leadTime} ساعت</td>
              <td>
                <span
                  className="badge alert alert-secondary py-2"
                  style={{
                    borderRadius: 150,
                    paddingLeft: 10,
                    paddingRight: 10,
                  }}
                >
                  {variant?.shippingNature?.text || ""}
                </span>
              </td>
              <td className="text-center">{variant.count}</td>
              <td className="text-center">{formatMoney(variant.price)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
